import React, { useState } from "react";
import { Button, Modal, Tabs } from "antd";
import ReactDOM from "react-dom";
import { CreateTeamAndEmployee } from "@/types/LoginPage";
import bus from "@/utils/bus";
import styles from './index.module.less'
import { useTranslation } from "react-i18next";
import okPNG from "@/components/UploadBox/imgs/ok.png";
export enum MenuType {
  AddThirdApp = "addThirdApp", // 添加常用
  CreateTeamSuccessModal = "CreateTeamSuccessModal" // 关于应用
}

interface IProps {
  enterApplication: Function;
  removeNode: Function;
  info: CreateTeamAndEmployee;
  isLogin: boolean;
}

function CreateTeamSuccessModal(props: IProps) {
  const { removeNode, enterApplication, info, isLogin } = props;
  const { t } = useTranslation("common");
  const openJoinTeamModal = () => {
    enterApplication?.();
    if (!isLogin) {
      localStorage.setItem("openJoinTeamModal" + info?.teamId, "1");
    } else {
      setTimeout(() => {
        // console.log("openJoinTeamModal>ls");
        bus.emit("openJoinTeamModal", {
          teamId: info?.teamId
        });
      }, 300);
    }
    removeNode?.();
  };
  return (
    <Modal
      className={styles.CreateTeamSuccess}
      width={520}
      title={null}
      footer={null}
      visible={true}
      onCancel={() => {
        removeNode?.();
      }}
    >
      <div className={styles["CreateTeamSuccess-body"]}>
        <div style={{display: "inline-flex"}}>
        <img src={okPNG} width="22px"/>
        <div className={styles["CreateTeamSuccess-title"]}>{t("createTeam.success")}</div>
        </div>
        <div className={styles["CreateTeamSuccess-info"]}>{t("createTeam.info")}<span style={{color: "@primary-color"}}>{t("createTeam.manageSys")}</span></div>
        <div
          className={styles["CreateTeamSuccess-enterApplication"]}
          onClick={() => {
            removeNode?.();
            enterApplication?.();
          }}
        >
          {t("createTeam.enterApplication")}
        </div>
        <Button className={styles["CreateTeamSuccess-invite"]} type="primary" onClick={openJoinTeamModal}>
          {t("createTeam.invite")}
        </Button>
      </div>
    </Modal>
  );
}

export default function openCreateTeamSuccessModal(props: any) {
  const ele = document.createElement("div");
  document.body.appendChild(ele);
  function removeNode() {
    if (ele) {
      ReactDOM.unmountComponentAtNode(ele);
      ele.remove();
    }
  }
  ReactDOM.render(<CreateTeamSuccessModal {...{ ...props, removeNode }} />, ele);
}
